import React from 'react'
import { Link } from "react-router-dom";
import Modal from 'react-responsive-modal';

const ProjectConfirmationModal = ({open, onClose, updateAdminMode }) => {
	return (
      <Modal  
            classNames={{ modal: 'confirmation-modal-overlay' }}
      	open={open} 
      	onClose={onClose} little>
          
      <h2 className="reveal-title">Confirmation</h2> 


      <div className="content">
            <p>This will close your Admin Area and enter into Artist Mode so they can begin Registerin/Checkin-in</p>
            <p>Are you sure you wish to proceed?</p>
      </div>          
      
      <div className="clearfix"></div>
      <div className="modal-actions">
            <button 
            	className="button hollow float-left cancel" 
            	onClick={onClose}>Cancel</button>
            <button 
            	className="button float-right proceed" 
            	onClick={updateAdminMode}>Proceed</button>
      </div>
    </Modal>
	)
}

export default ProjectConfirmationModal





// WEBPACK FOOTER //
// ./src/components/modals/ProjectConfirmationModal.js